export const colors = {
    blue: "Azul",
    turquoise: "Turquesa",
    green: "Verde",
    red: "Rojo",
    orange: "Naranja",
    yellow: "Amarillo",
    violet: "Violeta",
};
